import BaseModal from 'ext-ui/components/BaseModal/BaseModal'
import React from 'react'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'

interface CancelOrDeactivateVirtualCardsPopupProps {
  title: React.ReactNode
  subtitle: React.ReactNode
  actionButtonLabel: React.ReactNode
  actionButtonLoading?: boolean
  actionButtonOnClick: () => void
  cancelButtonLabel: React.ReactNode
  cancelButtonOnClick?: () => void
  topLevelError?: string
  // Accessible label for the dialog — ext-ui BaseModal requires `aria-label`.
  ariaLabel: string
  // Close handler for the modal's X / Esc / overlay-click. Defaults to the
  // cancel-button handler (both should close the overlay).
  onClose?: () => void
}

const noop = (): void => {}

const CancelOrDeactivateVirtualCardsPopup: React.FC<
  CancelOrDeactivateVirtualCardsPopupProps
> = (props) => {
  // A close handler exists when either `onClose` or the cancel handler is
  // supplied (every current call site passes `cancelButtonOnClick`). When one
  // does, the X button and the Esc key are both wired so a keyboard user always
  // has a close path (WCAG 2.1.1); when none is, the X is hidden so it never
  // degrades to a no-op. Overlay-click stays disabled either way so a
  // destructive confirm is not dismissed by a stray click outside the card.
  const hasCloseHandler =
    props.onClose !== undefined || props.cancelButtonOnClick !== undefined
  return (
    // BaseModal supplies the card surface (ConfirmationPopupContent is unstyled).
    <BaseModal
      isOpen
      onClose={props.onClose ?? props.cancelButtonOnClick ?? noop}
      aria-label={props.ariaLabel}
      showCloseButton={hasCloseHandler}
      shouldCloseOnEsc={hasCloseHandler}
      shouldCloseOnOverlayClick={false}
    >
      <ConfirmationPopupContent
        title={props.title}
        subtitle={props.subtitle}
        actionButtonLabel={props.actionButtonLabel}
        actionButtonLoading={props.actionButtonLoading}
        actionButtonOnClick={props.actionButtonOnClick}
        cancelButtonLabel={props.cancelButtonLabel}
        cancelButtonOnClick={props.cancelButtonOnClick}
        topLevelError={props.topLevelError}
      />
    </BaseModal>
  )
}

export default CancelOrDeactivateVirtualCardsPopup
